import { Text, ToggleDetails } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import DataGrid from "react-data-grid";
import { buildLMGTable } from "../utils";

const LMGSummary = ({ roundingMethod, results }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const { outcomeColumns, studentRows } = buildLMGTable(
      results,
      roundingMethod
    );
    setColumns(outcomeColumns);
    setRows(studentRows);
  }, [results, roundingMethod]);

  return (
    <>
      <Text>
        <Text weight="bold">{t("finalizeCourse.roundingMethod")}: </Text>
        {roundingMethod === "roundHalfUp"
          ? t("finalizeCourse.roundHalfUp")
          : t("finalizeCourse.roundDown")}
      </Text>
      <ToggleDetails summary={t("finalizeCourse.toggleResults")}>
        <DataGrid
          className="rdg-light"
          rowHeight={60}
          headerRowHeight={40}
          columns={columns}
          rows={rows}
        />
      </ToggleDetails>
    </>
  );
};

export default LMGSummary;
